export const DEFAULT_JOINT_FUNDS = {
  download_transaction_statements: null,
  download_transaction_statements_loading: false,

  contribute_funds: null,
  contribute_funds_loading: false,

  get_general_contributions: null,
  get_general_contributions_pagination: null,
  get_general_contributions_loading: false,

  get_personal_contributions: null,
  get_personal_contributions_totals: null,
  get_personal_contributions_pagination: null,
  get_personal_contributions_loading: false,

  get_general_amount_settings: null,
  get_general_amount_settings_loading: false,

  set_general_amount: null,
  set_general_amount_loading: false,

  transfer_to_wallet: null,
  transfer_to_wallet_loading: false,

  get_joint_fund_wallet: null,
  get_joint_fund_wallet_loading: false,

  error: {
    download_transaction_statements_error: null,
    contribute_funds_error: null,
    get_general_contributions_error: null,
    get_personal_contributions_error: null,
    get_general_amount_error: null,
    set_general_amount_error: null,
    transfer_to_wallet_error: null,
    get_joint_fund_wallet_error: null,
  }
}
